
import { create } from 'zustand'

interface InsufficientBalanceState {
  open: boolean
  requiredAmount: string | null
  currentBalance: string | null
  showInsufficientBalance: (requiredAmount?: string, currentBalance?: string) => void
  hideInsufficientBalance: () => void
}

export const useInsufficientBalanceStore = create<InsufficientBalanceState>((set) => ({
  open: false,
  requiredAmount: null,
  currentBalance: null,
  showInsufficientBalance: (requiredAmount?: string, currentBalance?: string) =>
    set({ open: true, requiredAmount: requiredAmount ?? null, currentBalance: currentBalance ?? null }),
  hideInsufficientBalance: () =>
    set({ open: false, requiredAmount: null, currentBalance: null }),
}))
